import { IBienLaiViewChiTietActionTypes } from "../../action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import {
  IBienLaiViewChiTietReducer,
  IBienLaiViewChiTietReducerItem,
} from "../../reducer-model/bien-lai/IBienLaiViewChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiViewChiTietReducer = {
  bienLais: [],
};
export const bienLaiViewChiTietReducer = (
  state: IBienLaiViewChiTietReducer = iniState,
  action: IBienLaiViewChiTietActionTypes
): IBienLaiViewChiTietReducer => {
  switch (action.type) {
    case "BIEN_LAI_VIEW_CHI_TIET_LOAD_START":
      let obj_load_start = state.bienLais.find(
        (bienLai) => bienLai.id_bien_lai === action.payload
      );
      return {
        ...state,
        bienLais: [
          ...state.bienLais.filter(
            (bienLai) => bienLai.id_bien_lai !== action.payload
          ),
          {
            ...obj_load_start,
            id_bien_lai: action.payload,
            status: eReducerStatusBase.is_loading,
          },
        ],
      };
    case "BIEN_LAI_VIEW_CHI_TIET_LOAD_SUCCESS":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (bienLai.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...bienLai,
              bienLaiViewModel: action.payload,
              status: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    case "BIEN_LAI_VIEW_CHI_TIET_LOAD_ERRR":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (bienLai.id_bien_lai === action.payload.request.id) {
            return {
              ...bienLai,
              bienLaiViewModel: undefined,
              status: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    case "BIEN_LAI_VIEW_CHI_TIET_PRINT_START":
      let obj_print_start =
        state.bienLais.find(
          (bienLai) => bienLai.id_bien_lai === action.payload.id
        ) ?? ({} as IBienLaiViewChiTietReducerItem);
      return {
        ...state,
        bienLais: [
          ...state.bienLais.filter(
            (bienLai) => bienLai.id_bien_lai !== action.payload.id
          ),
          {
            ...obj_print_start,
            id_bien_lai: action.payload.id,
            status: eReducerStatusBase.is_completed,
            htmlTemplate: !action.payload.is_nop
              ? undefined
              : obj_print_start?.htmlTemplate,
            htmlTemplate2: action.payload.is_nop
              ? undefined
              : obj_print_start?.htmlTemplate2,
            statusPrint: eReducerStatusBase.is_loading,
          },
        ],
      };

    case "BIEN_LAI_VIEW_CHI_TIET_PRINT_SUCCESS":
      return {
        ...state,
        bienLais:
          state.bienLais?.map((bienLai) => {
            if (bienLai.id_bien_lai === action.payload.request.id) {
              return {
                ...bienLai,
                htmlTemplate: !action.payload.request.is_nop
                  ? action.payload.data
                  : bienLai.htmlTemplate,
                htmlTemplate2: action.payload.request.is_nop
                  ? action.payload.data
                  : bienLai.htmlTemplate2,
                statusPrint: eReducerStatusBase.is_completed,
                is_nop: action.payload.request.is_nop,
              };
            }
            return bienLai;
          }) ??
          ([
            {
              id_bien_lai: action.payload.request.id,
              htmlTemplate: !action.payload.request.is_nop
                ? action.payload.data
                : undefined,
              htmlTemplate2: action.payload.request.is_nop
                ? action.payload.data
                : undefined,
              statusPrint: eReducerStatusBase.is_completed,
            },
          ] as IBienLaiViewChiTietReducerItem[]),
      };
    case "BIEN_LAI_VIEW_CHI_TIET_PRINT_ERR":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (bienLai.id_bien_lai === action.payload.request.id) {
            return {
              ...bienLai,
              htmlTemplate: !action.payload.request.is_nop
                ? undefined
                : bienLai.htmlTemplate,
              htmlTemplate2: action.payload.request.is_nop
                ? undefined
                : bienLai.htmlTemplate2,
              statusPrint: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    default:
      return state;
  }
};
